import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'

//components
import PasswordComp from '../../components/signin/Password'
// images
import Logo from '../../assets/image/logo/ic-logo-ho.svg'
// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'
// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

export default function ResetPassword() {
  //기존: ChangePassword
  const [oldPwd, setOldPwd] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPassword2, setNewPassword2] = useState('')
  const [pwdClientMsg, setPwdClientMsg] = useState('')
  const [issue, setIssue] = useState()

  const navigate = useNavigate()
  const location = useLocation()

  const [loginId, setLoginId] = useState(location?.state?.loginId)
  const { fetchData, loading, data, error } = useAxios()

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const issue = queryParameters.get('issue')
    setIssue(issue)
  }, [])
  const resetPasswordAPI = () => {
    if (!loginId) return

    const requestBody = {
      loginId,
      currPassword: oldPwd,
      newPassword: newPassword,
    }
    fetchData(
      constants.API.RESET_PASSSWORD,
      'PATCH', // method
      requestBody, // data
    )
  }
  useEffect(() => {
    if (data?.responseCode == TYPE.API_RESPONSE.SUCCESS) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) localStorage.removeItem('user')
      navigate('/signin')
    } else if (data?.responseCode == TYPE.API_RESPONSE.MEMBER_9992) {
      setPwdClientMsg('계정 정보를 찾을 수 없습니다.')
    }
  }, [data])

  useEffect(() => {
    if (error?.response?.status == TYPE.API_RESPONSE.GATEWAY_TIMEOUT) {
      setPwdClientMsg('현재 비밀번호가 올바르지 않습니다.')
    }
  }, [error])

  return (
    <Container>
      <Wrapper>
        <ContentWrapper>
          <img src={Logo} className="" onClick={() => navigate('/signin')} />
          <TitleTextWrapper>
            <TitleText>해피오더 사장님</TitleText>
          </TitleTextWrapper>

          <PwdMsgText>비밀번호를 변경해주세요</PwdMsgText>
          {issue == 'inactive' ? (
            <ResetPwd>
              비밀번호를 변경한지 180일이 경과하였습니다. 개인정보 보호를 위해
              <br />
              비밀번호를 다시 설정해주세요.
            </ResetPwd>
          ) : (
            <ClientMessage>
              미접속 기간이 90일을 초과하여 계정이 정지되었습니다. 로그인을
              원하시면 비밀번호를 다시 설정해주세요.
            </ClientMessage>
          )}
          <Input
            type="password"
            placeholder="현재 비밀번호"
            value={oldPwd}
            className="prevPwd"
            onChange={(e) => setOldPwd(e.target.value)}
          />

          <PasswordComp
            setNewPassword={setNewPassword}
            setNewPassword2={setNewPassword2}
            newPassword={newPassword}
            newPassword2={newPassword2}
            resetReason={'180days'}
            updatePasswordAPI={resetPasswordAPI}
            pwdClientMsg={pwdClientMsg}
            setPwdClientMsg={setPwdClientMsg}
          />
          <TradeMarkWrapper>
            <TradeMarkText>
              Copyright ⓒ by SPC ALL RIGHTS RESERVED.
            </TradeMarkText>
          </TradeMarkWrapper>
        </ContentWrapper>
      </Wrapper>
    </Container>
  )
}
const ContentWrapper = styled.div`
  position: relative;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
`

const Wrapper = styled.div`
  img {
    width: 129.3px;
    height: 50px;
    cursor: pointer;
  }
  width: 430px;
  height: 801px;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(102, 102, 102, 0.1);
  background-color: #fff;
  padding: 50px 30px 30px;
  display: flex;
  justify-content: center;
  color: #8a8a8a;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
    width: 430px;
    height: 760px;
    box-shadow: none;
  }
`
const TitleTextWrapper = styled.div`
  margin: 15px 0px 25px;
  @media ${(props) => props.theme.mobile} {
  }
`
const PwdMsgText = styled.div`
  margin: 53px 73px 6px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #000;
  @media ${(props) => props.theme.mobile} {
    margin: 45px 0px 6px 0px;
  }
`
const TitleText = styled.span`
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: #00402e;
  @media ${(props) => props.theme.mobile} {
    font-size: 22px;
  }
`
const Input = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 360px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 30px;
  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
  .prevPwd {
    margin-bottom: 30px;
  }
`

const TradeMarkWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  @media ${(props) => props.theme.mobile} {
  }
`

const TradeMarkText = styled.span`
  font-size: 12px;
  color: #a8a8a8;
  @media ${(props) => props.theme.mobile} {
  }
`
const ResetPwd = styled.div`
  width: 268px;
  height: 60px;
  font-size: 14px;
  text-align: left;
  color: #8a8a8a;
  margin: auto;
  text-align: center;
  margin-bottom: 55px;
  @media ${(props) => props.theme.mobile} {
    width: 268px;
    margin-bottom: 48px;
  }
`
const ClientMessage = styled.div`
  width: 318px;
  height: 40px;
  font-size: 14px;
  text-align: left;
  color: #8a8a8a;
  margin: auto;
  text-align: center;
  margin-bottom: 55px;
  @media ${(props) => props.theme.mobile} {
    width: 286px;
  }
`
